import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { reactive, toRefs, watch } from 'vue';
import apis from "@/api";
import { srcType } from "@/utils/srcType";
export default {
  props: {
    show: Boolean,
    id: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:show', 'chooseHandler'],
  setup(props, {
    emit
  }) {
    let data = reactive({
      form: {
        posId: props.id,
        posChannel: "",
        tagNum: "",
        tagName: "",
        keys: "",
        status: "1",
        pageSize: 10,
        pageNum: 1
      },
      assetsList: [],
      total: 0,
      srcType: srcType
    });
    const fetchData = () => {
      if (!props.id) return;
      apis.assetsSearch(data.form).then(res => {
        if (res.success) {
          // ctx.emit("update:modelValue", res.data);
          data.assetsList = res.data.assets;
          data.total = res.data.total;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const onSubmit = () => {
      fetchData();
    };
    const reset = () => {
      data.form = {
        posId: props.id,
        posChannel: "",
        tagNum: "",
        tagName: "",
        keys: "",
        status: "1",
        pageSize: 10,
        pageNum: 1
      };
    };
    watch(() => props.id, () => {
      reset();
      fetchData();
    }, {
      immediate: true
    });
    watch(() => data.form.pageNum, () => {
      fetchData();
    });
    const chooseHandler = item => {
      emit('chooseHandler', item);
      emit('update:show', false);
    };
    return {
      ...toRefs(data),
      onSubmit,
      reset,
      chooseHandler
    };
  }
};